import { MutationTree } from 'vuex';

const mutations: MutationTree<any> = {
  setUser(state, user) {
    state.auth.user = user;
  },
  setAuthAccessToken(state, token) {
    state.auth.accessToken = token;
  },
  setAuthRefreshToken(state, token) {
    state.auth.refreshToken = token;
  },
  setLoggedIn(state, loggedIn) {
    state.auth.isLoggedIn = loggedIn;
  },
  setLoading(state, loading) {
    state.loading = loading;
  },
  setBlockAppLoading(state, loading) {
    state.blockAppLoading = loading;
  },
  setPlayingSong(state, song) {
    state.player.playingSong = song;
    state.player.artworkSmUrl = song?.albumArtworkSmUrl;
    state.player.artworkLgUrl = song?.albumArtworkLgUrl;
    state.player.defaultArtwork = song?.defaultArtwork;
  },
  setPlayingSongArtwork(state, artworkUrl) {
    state.player.artworkSmUrl = artworkUrl;
    state.player.artworkLgUrl = artworkUrl;
  },
  setPlayingFile(state, file) {
    state.player.playingFile = file;
  },
  setPaused(state, paused) {
    state.player.paused = paused;
  },
  setCurrentTime(state, currentTime) {
    state.player.currentTime = currentTime;
  },
  setPercentComplete(state, percentComplete) {
    state.player.percentComplete = percentComplete;
  },
  setPlayerTimes(state, times) {
    state.player.duration = times.duration;
    state.player.currentTime = times.currentTime;
    state.player.percentComplete = times.currentTime / times.duration;
  },
  setVolume(state, volume) {
    state.player.volume = volume;
  },
  setAppUser(state, user) {
    state.user = user;
  },
  setLibraryRefresh(state, refresh) {
    state.triggerLibraryRefresh = refresh;
  },
  setLibraryRefreshLoading(state, refreshing) {
    state.libraryRefreshLoading = refreshing;
  },
  startFileUpload(state, { songId, file }) {
    state.uploadingFile.uploading = true;
    state.uploadingFile.file = file;
    state.uploadingFile.songId = songId;
  },
  setUploadingFilePercentage(state, percentage) {
    state.uploadingFile.percentage = percentage;
  },
  setUploadingFileId(state, fileId) {
    state.uploadingFile.fileId = fileId;
  },
  finishFileUpload(state) {
    state.uploadingFile.uploading = false;
    state.uploadingFile.file = null;
    state.uploadingFile.songId = null;
    state.uploadingFile.percentage = 0;
    state.uploadingFile.fileId = null;
  },
  playPlaylist(state, { playlist, songs }) {
    state.player.playingPlaylist = playlist;
    state.player.playlistSongs = songs;
    state.player.isPlaylistPlaying = true;
  },
  incrementPlaylistIndex(state) {
    state.player.playlistIndex += 1;
  },
  decrementPlaylistIndex(state) {
    state.player.playlistIndex -= 1;
  },
  setPlaylistIndex(state, index) {
    state.player.playlistIndex = index;
  },
  resetPlayerPlaylist(state) {
    state.player.playlistIndex = 0;
    state.player.playingPlaylist = null;
    state.player.isPlaylistPlaying = false;
    state.player.playlistSongs = [];
  },
  setPlayingSongInfo(state, { title, artist }) {
    state.player.playingSong = {
      ...state.player.playingSong,
      title,
      artist,
    };
  },
  setKeyboardOpen(state, open) {
    state.keyboard.open = open;
  },
  setLdInitialized(state) {
    state.ldInitialized = true;
  },
};

export default mutations;
